import { ReactNode } from "react"
import {
  FloatingTooltip,
  FloatingTooltipProps,
} from "shared-web/components/base/overlay/FloatingTooltip"

interface DisabledWithTooltipProps {
  children: ReactNode
  isDisabled?: boolean
  message?: string
  placement?: FloatingTooltipProps["placement"]
}

type DisabledWithTooltipPlacedProps = Omit<
  DisabledWithTooltipProps,
  "placement"
>

export function DisabledWithTooltip({
  children,
  isDisabled,
  message,
  placement = "top-start",
}: DisabledWithTooltipProps) {
  if (!isDisabled) return <>{children}</>
  if (!message) return <>{children}</>

  return (
    <FloatingTooltip
      content={<Message message={message} />}
      placement={placement}
      className="surface-primary-inverted w-[250px]"
      trigger={children}
    />
  )
}

export function DisabledReturnTooltip(props: DisabledWithTooltipPlacedProps) {
  return <DisabledWithTooltip {...props} placement="bottom-start" />
}

export function DisabledVoidTooltip(props: DisabledWithTooltipPlacedProps) {
  return <DisabledWithTooltip {...props} placement="bottom-start" />
}

function Message({ message }: { message: string }) {
  return (
    <span className="text-primary-inverted text-xs font-normal">{message}</span>
  )
}
